import { Form, Grid, ISelectOption, Panel, Select, SingleColumnLayout } from '@salecycle/ui-component-library';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { IClients } from '../../../../entities';
import { updateStepValidityAction } from '../../actions';
import { useNewUserDispatch, useNewUserState } from '../../context/useNewUserContext';
import { isAccessLevelValid } from '../../../../utils/helpers';
import { BrandAccessLevel } from './accessLevel/BrandAccessLevel';
import { SiteAccessLevel } from './accessLevel/SiteAccessLevel';
import { MultiSiteAccessLevel } from './accessLevel/MultiSiteAccessLevel';
import NewUserSidebar from '../NewUserSidebar';
import { getAccessLevelOptions } from 'sections/user-management/utils/helpers';

export interface IProps {
  clients: IClients;
  currentStep: number;
}

/* eslint-disable react-hooks/exhaustive-deps */
export const AccessLevelStep: React.FC<IProps> = ({ clients, currentStep }: IProps) => {
  const { t } = useTranslation();
  const { user, validSteps } = useNewUserState();
  const dispatch = useNewUserDispatch();
  const accessLevelOptions = getAccessLevelOptions(t);

  React.useEffect(() => {
    updateStepValidityAction(isAccessLevelValid(user), validSteps, currentStep, dispatch);
  }, [user]);

  const handleAccessLevelChange = (selectedOption: ISelectOption<string>) => {
    dispatch({
      type: 'SET_SELECTED_ACCESS_LEVEL',
      payload: { selectedAccessLevel: selectedOption },
    });
  };

  return (
    <SingleColumnLayout
      paddingLeft={20}
      heading={t('newUser.accessLevelStep.heading')}
      showSidebar={true}
      sidebar={<NewUserSidebar currentStep={currentStep} />}
      sidebarHeading={t('newUser.sidebar.title')}
    >
      <Grid>
        <Panel variation="clean">
          <Form>
            <Select
              ariaLabel={t('newUser.accessLevelStep.accessLevel.label')}
              label={t('newUser.accessLevelStep.accessLevel.label')}
              inputId="AccessLevelSelect"
              onChange={handleAccessLevelChange}
              options={accessLevelOptions}
              value={user.selectedAccessLevel}
              clearable={true}
            />

            {user.selectedAccessLevel && user.selectedAccessLevel.value === 'Brand' && (
              <BrandAccessLevel clients={clients} />
            )}
            {user.selectedAccessLevel && user.selectedAccessLevel.value === 'Site' && (
              <SiteAccessLevel clients={clients} />
            )}
            {user.selectedAccessLevel && user.selectedAccessLevel.value === 'MultiSite' && (
              <MultiSiteAccessLevel clients={clients} />
            )}
          </Form>
        </Panel>
      </Grid>
    </SingleColumnLayout>
  );
};

export default AccessLevelStep;
